import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';

import ContentSlider from '../../../components/content-slider/ContentSlider';
import ContentSlide from '../../../components/content-slide/ContentSlide';
import TagList from '../../../components/tag-list/TagList';
import { addTagFilter } from '../../../../redux/activ8/activ8Reducer';
import { ACTIV8_CONTENT_STATUS } from '../../../../constants';
import { MEDIA_LINK_VARIANTS } from '../../../utils/resolveActiv8MediaLink';
import { clampMediaIndex } from '../../../utils/mediaIndex';
import ExpiredBadge from './expired-badge/ExpiredBadge';

import scss from './ContentCard.module.scss';

function ContentCard({
  media,
  bucketId,
  onPreview,
  onLike,
  onDownload,
  onDownloadSource,
  onStudio,
  onDelete,
  onStory,
  onRestore,
  enableTagFilter = true,
}) {
  const dispatch = useDispatch();
  const [slideIndex, setSlideIndex] = useState(0);

  const mediaLength = media?.length ?? 0;
  const safeIndex = clampMediaIndex(slideIndex, mediaLength);

  useEffect(() => {
    setSlideIndex((index) => clampMediaIndex(index, mediaLength));
  }, [mediaLength]);

  const handleOpenPreview = () => {
    onPreview({ bucketId, initialIndex: safeIndex });
  };

  const handleLike = (slide) => {
    onLike(slide);
  };

  const handleDownload = (slide) => {
    onDownload(slide);
  };

  const handleDownloadSource = async (slide) => {
    await onDownloadSource(slide);
  };

  const handleOpenStudio = () => {
    onStudio({ media, slideIndex: safeIndex, bucketId });
  };

  const handleOpenStory = () => {
    onStory(media[safeIndex]);
  };

  const handleRestore = (slide) => {
    onRestore(slide);
  };

  const handleTagSelect = (tag) => {
    dispatch(addTagFilter(tag));
  };

  const handleSwipe = (_, next) => {
    setSlideIndex(next);
  };

  const handleCopyLink = (link) => {
    navigator.clipboard.writeText(link);
  };

  const isExpired = media?.[safeIndex]?.status === ACTIV8_CONTENT_STATUS.EXPIRED;

  const slideProps = {
    className: scss.contentSlide,
    imageClassName: scss.image,
    videoClassName: scss.video,
    mediaLinkVariant: MEDIA_LINK_VARIANTS.THUMBNAIL,
    aiGeneratedSize: 'sm',
    onPreview: onPreview ? handleOpenPreview : undefined,
    onLike: onLike ? handleLike : undefined,
    onDownload: onDownload ? handleDownload : undefined,
    onDownloadSource: onDownloadSource ? handleDownloadSource : undefined,
    onStudio: onStudio ? handleOpenStudio : undefined,
    onCopyLink: onLike || onDownload ? handleCopyLink : undefined,
    onDelete: onDelete,
    onStory: onStory ? handleOpenStory : undefined,
    onRestore: onRestore ? handleRestore : undefined,
  };

  return (
    <div className={scss.card}>
      <div className={scss.sliderWrapper}>
        {isExpired ? <ExpiredBadge /> : null}
        <ContentSlider
          slides={media}
          Slide={ContentSlide}
          contrastedArrows
          slideProps={slideProps}
          index={safeIndex}
          onSwipe={handleSwipe}
        />
      </div>
      <div className={clsx(isExpired && scss.expiredContent)}>
        <TagList
          tags={media?.[safeIndex]?.tags}
          onClickTag={isExpired || !enableTagFilter ? undefined : handleTagSelect}
          isExpandable
        />
      </div>
    </div>
  );
}

export default ContentCard;
